import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ModalHerramientasYControlesPage } from './modal-herramientas-ycontroles.page';

const routes: Routes = [
  {
    path: '',
    component: ModalHerramientasYControlesPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ModalHerramientasYControlesPageRoutingModule {}
